import React from "react";
import styled from "styled-components";
import { media } from "../../../../../constants/styles";
import { valueUpServices } from "../../../../../constants/valueUpServices";
import { Wrapper } from "../../../shared/styled";
import { SectionProps } from "../../../shared/types";
import ValueUpCard from "./VaueUpCard";

const ValueUpCardList: React.FC<SectionProps> = ({ screenType }) => {
  const services = valueUpServices;
  return (
    <Container>
      <CardSectionWrapper>
        {services.map((service, idx) => {
          return (
            <ValueUpCard
              idx={idx}
              screenType={screenType}
              service={service}
              key={service.title}
            />
          );
        })}
      </CardSectionWrapper>
    </Container>
  );
};
export default ValueUpCardList;

const CardSectionWrapper = styled(Wrapper)`
  gap: 140px;
  margin: 0 auto;
  ${media.TABLET} {
    gap: 80px;
    align-items: center;
  }

  ${media.MOBILE} {
    gap: 60px;
  }
`;

const Container = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 76px;
  gap: 200px;
  isolation: isolate;
  overflow: hidden;

  ${media.MOBILE} {
    width: 100%;
    padding-top: 36px;
  }
`;
